import {
    CheckoutOrderModel,
    CheckoutOrderView,
    CheckoutOrderViewAccessory,
    CheckoutOrderViewItem,
} from "../../basket/checkoutOrderView";

export interface CheckoutOrderPriceSummary {
    readonly itemsAmount: number;
    readonly itemsAmountWithoutDiscount: number;
    readonly itemsAndAccessoriesAmount: number;
}

export default new class CheckoutOrderModelPriceService {
    public getPriceSummary(checkoutOrderView: CheckoutOrderView): CheckoutOrderPriceSummary {
        const itemsAmount = this.sumItemsAmount(checkoutOrderView.items);
        const accessoriesAmount = this.sumAccessoriesAmount(checkoutOrderView.orderAccessories);
        const itemsAmountWithoutDiscount = this.sumItemsAmountWithoutDiscount(checkoutOrderView.items);
        const itemsAndAccessoriesAmount = itemsAmount + accessoriesAmount;

        return {
            itemsAmount,
            itemsAmountWithoutDiscount,
            itemsAndAccessoriesAmount,
        };
    }

    public getShippingPrice(checkoutOrderModel: CheckoutOrderModel): number {
        if (checkoutOrderModel.eshopShippingServiceId === null) {
            return 0;
        }

        const shippingService = checkoutOrderModel.eshopShippingServices
            .find((service) => service.ids.includes(checkoutOrderModel.eshopShippingServiceId ?? -1));

        if (shippingService === undefined) {
            return 0;
        }

        return shippingService.prices[checkoutOrderModel.eshopShippingServiceId];
    }

    public getPaymentPrice(checkoutOrderModel: CheckoutOrderModel): number {
        if (checkoutOrderModel.eshopPaymentServiceId === null) {
            return 0;
        }

        const paymentService = checkoutOrderModel.eshopPaymentServices.find(
            (service) => service.id === checkoutOrderModel.eshopPaymentServiceId,
        );

        if (paymentService === undefined) {
            return 0;
        }

        return paymentService.price;
    }

    private sumItemsAmount(items: CheckoutOrderViewItem[]): number {
        let price = 0;

        for (const item of items) {
            price += item.priceWithDiscount * item.quantity;
        }

        return price;
    }

    private sumAccessoriesAmount(orderAccessories: CheckoutOrderViewAccessory[]): number {
        let price = 0;

        for (const orderAccessory of orderAccessories) {
            price += orderAccessory.price;
        }

        return price;
    }

    private sumItemsAmountWithoutDiscount(items: CheckoutOrderViewItem[]): number {
        let price = 0;

        for (const item of items) {
            price += item.price * item.quantity;
        }

        return price;
    }
}();
